"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardCard = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const reporting_context_1 = require("../reporting/reporting-context");
const card_universal_1 = require("./cards/universal/card-universal");
const card_add_1 = require("./cards/add/card-add");
const dashboard_context_1 = require("./dashboard-context");
function DashboardCard({ id }) {
    const { cardFactory } = react_1.useContext(dashboard_context_1.DashboardContext);
    const { url } = react_1.useContext(reporting_context_1.ReportingContext);
    const [report, setReport] = react_1.useState();
    const source = crud_source_hook_1.useCrudSource({
        url,
        handleGetError: lodash_1.noop,
    });
    const load = event_callback_hook_1.useEventCallback(async () => {
        if (id !== 'ADD') {
            const report = await source.get(id);
            setReport(report !== null && report !== void 0 ? report : undefined);
        }
    });
    react_1.useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    const CardComponent = combinedCardFactory(id, cardFactory);
    return (react_1.default.createElement(CardComponent, { report: report, load: load, loading: source.loading, definitionId: id }));
}
exports.DashboardCard = DashboardCard;
function combinedCardFactory(definitionId, cardFactory) {
    var _a;
    if (definitionId === 'ADD') {
        return card_add_1.CardAdd;
    }
    else {
        return (_a = cardFactory(definitionId)) !== null && _a !== void 0 ? _a : card_universal_1.CardUniversal;
    }
}
//# sourceMappingURL=dashboard-card.js.map